module.exports = __webpack_public_path__ + "img/light-bulb.f1a44432.svg";